"use strict";
/**
 * El espejo de QVET, forma nueva. GH527, tarea T4.
 *
 * Sustituye al espejo plano de 41 campos por: **escalares planos** —que es lo que hace
 * posibles las guardas de exhaustividad en tiempo de compilación— **más cinco colecciones**,
 * porque `tariffs[2].pricePVP` no es una clave plana y no se puede expresar en un mapa.
 *
 * Nombres en inglés y **por lo que la cosa es**, no por cómo la llama QVET: la clave de QVET
 * queda en el mapa de escritura, que es donde tiene que estar la trazabilidad.
 *
 * Todo lo marcado como sólo lectura está **probado escribiendo contra QVET** el 2026-09-06,
 * no deducido: que QVET pinte un campo en gris no predice lo que su API acepta.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyQvetCollections = exports.QVET_PROMOTION_TYPE_LABELS = exports.QVET_PROMOTION_TYPES = void 0;
// ───────────────────────────────────────────────────────────────────────────────
// Promoción
// ───────────────────────────────────────────────────────────────────────────────
/**
 * El tipo de promoción, **con los valores que usa QVET**.
 *
 * Son los `value` de dos radios que se llaman `promocion_tipo`. Se guardan tal cual, no
 * traducidos: es lo que hay que devolverle a QVET al guardar, y un mapa de ida y vuelta es
 * una oportunidad más de equivocarse en un sitio donde equivocarse **borra un descuento**.
 * Ver la excepción de sistemas externos en `.claude/rules/enums.md`.
 */
exports.QVET_PROMOTION_TYPES = ['dto', 'pvp'];
exports.QVET_PROMOTION_TYPE_LABELS = {
    dto: '% de descuento',
    pvp: 'Precio fijo',
};
/**
 * Un espejo de colecciones vacío.
 *
 * Existe para que un documento anterior a esta forma —o un artículo recién dado de alta—
 * se lea sin ramas por todas partes: la ausencia de colecciones y unas colecciones vacías
 * significan lo mismo, «QVET no nos ha dicho nada de esto todavía».
 *
 * Devuelve un objeto nuevo cada vez a propósito: compartir uno congelado invitaría a que
 * dos artículos acabaran empujando filas al mismo array.
 */
const emptyQvetCollections = () => ({
    tariffs: [],
    supplierPrices: [],
    warehouses: [],
    lots: [],
    bundleComponents: [],
    medicine: null,
    posology: [],
    withdrawalPeriods: [],
    centerIds: [],
});
exports.emptyQvetCollections = emptyQvetCollections;
